// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

// Fire-and-forget frontend request-response observability. Reports each of this app's
// agent-related HTTP calls to a dedicated backend endpoint, which forwards them to a
// separate Langfuse project using server-side credentials. Never throws and never
// delays/blocks the caller - a tracing failure must not affect the real user flow.

export type FrontendCallType = 'start-interview' | 'get-assessment' | 'get-learning-paths';

export interface ReportAgentInteractionParams {
  sessionId?: string;
  callType: FrontendCallType;
  request?: unknown;
  response?: unknown;
  status: 'success' | 'error';
  errorMessage?: string;
  startTime: number;
  endTime: number;
}

export function reportAgentInteraction(params: ReportAgentInteractionParams): void {
  try {
    void fetch('/api/frontendTracing', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        sessionId: params.sessionId,
        callType: params.callType,
        request: params.request,
        response: params.response,
        status: params.status,
        errorMessage: params.errorMessage,
        startTime: new Date(params.startTime).toISOString(),
        endTime: new Date(params.endTime).toISOString()
      })
    }).catch((error) => {
      console.warn('[Frontend Tracing] Failed to report agent interaction:', error);
    });
  } catch (error) {
    console.warn('[Frontend Tracing] Failed to report agent interaction:', error);
  }
}
